var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DateTimePicker',{ref:"el",attrs:{"placeholder":"","inline":_vm.inline,"default-date":Object.values(_vm.value),"disable":_vm.disable,"mode":"range"},on:{"input":_vm.change,"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }